<template>
  <div class="login_wrapper">
    <div class="alert alert-secondary fade show" role="alert" v-if="show_msg">
      {{ message }}
    </div>

    <img src="@/assets/img/logo_ifood.png" alt="Logotipo do ifood materiais" />

    <div
      v-if="isLoadingToken"
      class="d-flex flex-column align-items-center justify-content-center py-5"
      data-test="login-loading"
    >
      <b-spinner label="Entrando" style="color: var(--red)" />
      <p class="mt-3">Carregando...</p>
    </div>

    <template v-else>
    <h1>
      {{
        show
          ? "Insira suas informações de cadastro para fazer login."
          : "Insira suas informações para realizar o cadastro"
      }}
    </h1>

    <b-form @submit.prevent.stop="onLogIn" v-if="show">
      <InputForm
        label="E-mail"
        id="input_email"
        type="email"
        v-model="form.email"
        :error="validateForm.errorM"
      />
      <InputForm
        label="Senha"
        id="input_password"
        type="password"
        v-model="form.password"
        :description="validateForm.errorPassword"
        :error="validateForm.errorP"
      />
      <b-button id="submit-btn" type="submit" variant="primary"
        >Entrar</b-button
      >
    </b-form>
    <b-form @submit.prevent.stop="onSignin" v-if="!show">
      <InputForm
        label="Nome completo"
        id="input_name"
        type="text"
        v-model="sign.name"
        :error="sign.errorName"
      />
      <InputForm
        label="E-mail"
        id="input_email"
        type="email"
        v-model="sign.email"
        :error="sign.errorMail"
      />
      <InputForm
        label="Criar senha"
        id="input_password"
        type="password"
        v-model="sign.password"
        :error="sign.errorPassword"
        :description="sign.errorMsg"
      />
      <InputForm
        label="Confirmar senha"
        id="input_confirm"
        type="password"
        v-model="sign.confirmPassword"
        :error="sign.errorPassword"
      />
      <InputForm
        label="Nome da empresa"
        id="input_company"
        type="text"
        v-model="sign.company"
        :error="sign.errorCompany"
      />
      <InputForm
        label="CNPJ"
        id="input_document"
        type="text"
        v-mask="'##.###.###/####-##'"
        v-model="sign.document"
        :error="sign.errorDocument"
      />
      <InputForm
        label="CEP"
        id="input_document"
        type="text"
        v-mask="'#####-###'"
        v-model="sign.zipCode"
      />

      <b-button id="submit-btn" type="submit" variant="primary"
        >Cadastrar</b-button
      >
    </b-form>
    <div v-show="show">
      Não possui cadastro?
      <button type="button" id="sign_btn" @keydown="signIn" @click="signIn">
        Cadastre-se
      </button>
    </div>
    </template>
  </div>
</template>

<script>
import InputForm from "@/components/form/InputForm.vue";
import Vue from "vue";
import VueTheMask from "vue-the-mask";
import { mapActions, mapGetters } from "vuex";
import encryptionService from "@/utils/encryptionService";
import userService from "@/services/userService";

Vue.use(VueTheMask);
export default {
  name: "LoginPage",
  data() {
    return {
      show_msg: false,
      message: "",
      show: true,
      checked: false,
      form: {
        email: "",
        password: "",
      },
      validateForm: {
        errorM: false,
        errorP: false,
        errorPassword: "",
      },
      sign: {
        document: "",
        company: "",
        email: "",
        password: "",
        confirmPassword: "",
        name: "",
        errorMail: false,
        errorPassword: false,
        errorDocument: false,
        errorCompany: false,
        errorName: false,
        errorMsg: "",
        zipCode: "",
      },
      isLoadingToken: false,
      prefilledFromToken: false,
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "isAuthenticated",
    }),
  },
  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const signedToken = urlParams.get("jwt");
    const encryptedToken = urlParams.get("token");
    const tk = urlParams.get("tk");
    const hasPathData =
      urlParams.get("data") &&
      urlParams.get("nam") &&
      urlParams.get("region") &&
      urlParams.get("uid");

    if (signedToken || encryptedToken || tk || hasPathData) {
      this.isLoadingToken = true;
    }

    if (signedToken) {
      await this.handleSignedToken(signedToken, urlParams.get("ret") || "");
      return;
    }

    if (encryptedToken) {
      await this.handleEncryptedToken(encryptedToken);
      return;
    }
    if (tk) {
      if (hasPathData) {
        await this.handleDriverLink(urlParams);
      } else {
        await this.handleDriverLinkWithFixedData(tk);
      }
      return;
    }
    if (hasPathData) {
      await this.handleDriverLinkFromEventos(urlParams);
    }
  },
  methods: {
    ...mapActions({
      login: "login",
      driver: "driver",
      signin: "signIn",
      register: "register",
      searchZip: "searchZip",
    }),
    async handleDriverLink(urlParams) {
      const SECRET = "cMq0#_NcIv66oWNY3e8jXXKWRivia";
      try {
        const decrypt = (encrypted) => {
          const raw = this.$CryptoJS.AES.decrypt(encrypted, SECRET);
          return raw.toString(this.$CryptoJS.enc.Utf8) || "";
        };
        const tk = decrypt(urlParams.get("tk"));
        const doc = decrypt(urlParams.get("data"));
        const nam = decrypt(urlParams.get("nam"));
        const region = decrypt(urlParams.get("region"));
        const uid = decrypt(urlParams.get("uid"));
        if (!tk) {
          this.showError("Falha ao descriptografar o token. Link inválido ou expirado.");
          return;
        }
        await this.driver({ doc, nam, tk, region, uid });
      } catch (err) {
        console.error("Erro no login automático:", err);
        this.showError(
          err.message || "Erro ao processar o link de login. Tente novamente ou use o login normal."
        );
      } finally {
        this.isLoadingToken = false;
      }
    },
    async handleDriverLinkWithFixedData(encryptedOrRawTk) {
      const SECRET = "cMq0#_NcIv66oWNY3e8jXXKWRivia";
      try {
        let token = encryptedOrRawTk;
        if (encryptedOrRawTk && encryptedOrRawTk.startsWith("U2F")) {
          const raw = this.$CryptoJS.AES.decrypt(encryptedOrRawTk, SECRET);
          token = raw.toString(this.$CryptoJS.enc.Utf8) || "";
        }
        if (!token) {
          this.showError("Token inválido ou falha ao descriptografar.");
          return;
        }
        const uid = process.env.VUE_APP_DEFAULT_DRIVER_ID || "7a346e14-5b76-4e59-8454-c9924fc848c7";
        const nam = process.env.VUE_APP_DEFAULT_DRIVER_NAME || "Rodrigo Tiseo";
        const region = process.env.VUE_APP_DEFAULT_DRIVER_REGION || "iFood";
        await this.driver({ doc: uid, nam, tk: token, region, uid });
      } catch (err) {
        console.error("Erro no login com token único:", err);
        this.showError(
          err.message || "Erro ao fazer login com o token. Tente o link completo ou login normal."
        );
      } finally {
        this.isLoadingToken = false;
      }
    },
    async handleDriverLinkFromEventos(urlParams) {
      const SECRET = "cMq0#_NcIv66oWNY3e8jXXKWRivia";
      this.isLoadingToken = true;
      let doc, nam, region, uid, password, ret;
      try {
        const decrypt = (encrypted) => {
          const raw = this.$CryptoJS.AES.decrypt(encrypted, SECRET);
          return raw.toString(this.$CryptoJS.enc.Utf8) || "";
        };
        doc = decrypt(urlParams.get("data"));
        nam = decrypt(urlParams.get("nam"));
        region = decrypt(urlParams.get("region"));
        uid = decrypt(urlParams.get("uid"));
        ret = urlParams.get("ret") || "";
        if (!uid || !doc || !nam) {
          this.showError("Link inválido. Dados incompletos.");
          return;
        }
        password = doc + "iFood!";
        await this.login({ username: uid, password });
        if (this.isAuthenticated) {
          this.persistEventosUserAndRedirect({ doc, nam, region, uid, ret });
          return;
        }
        const driverEmail = `${uid}@driver.ifoodmateriais.local`;
        await this.register({ username: uid, name: nam, email: driverEmail, password });
        await this.login({ username: uid, password });
        if (this.isAuthenticated) {
          this.persistEventosUserAndRedirect({ doc, nam, region, uid, ret });
          return;
        }
        this.showError("Não foi possível entrar. Tente novamente ou faça login manual.");
      } catch (err) {
        if (err.response && err.response.status === 409 && uid && password) {
          await this.login({ username: uid, password });
          if (this.isAuthenticated) {
            this.persistEventosUserAndRedirect({ doc, nam, region, uid, ret });
            return;
          }
        }
        console.error("Erro no login por link eventos:", err);
        this.showError(err.message || "Erro ao acessar. Tente novamente ou faça login manual.");
      } finally {
        this.isLoadingToken = false;
      }
    },
    persistEventosUserAndRedirect({ doc, nam, region, uid, ret }) {
      this.$store.commit("setDocument", doc);
      sessionStorage.setItem("document", doc);
      sessionStorage.setItem("region", region);
      sessionStorage.setItem("user", nam);
      sessionStorage.setItem("uid", uid);
      const eventosReturnUrl = this.resolveEventosReturnUrl(ret);
      if (eventosReturnUrl) {
        sessionStorage.setItem("eventos_return_url", eventosReturnUrl);
      }
      window.history.replaceState({}, document.title, window.location.pathname);
      this.$router.push("/meus-materiais");
    },
    async handleSignedToken(jwt, ret) {
      this.isLoadingToken = true;
      try {
        const payload = this.decodeJwtPayload(jwt);
        if (!payload || !payload.sub || !payload.doc) {
          this.showError("Link inválido ou expirado. Gere um novo link no app de eventos.");
          return;
        }
        sessionStorage.setItem("tokenLogin", jwt);
        sessionStorage.setItem("mobile", 1);
        this.$store.commit("SET_TOKEN", jwt);
        this.persistEventosUserAndRedirect({
          doc: payload.doc,
          nam: payload.nam || "",
          region: payload.region || "",
          uid: payload.sub,
          ret,
        });
      } catch (err) {
        console.error("Erro no login por token assinado:", err);
        this.showError("Erro ao processar o link. Tente novamente ou faça login manual.");
      } finally {
        this.isLoadingToken = false;
      }
    },
    decodeJwtPayload(jwt) {
      try {
        const part = (jwt || "").split(".")[1];
        if (!part) return null;
        const b64 = part.replaceAll("-", "+").replaceAll("_", "/");
        const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
        const json = decodeURIComponent(
          atob(padded)
            .split("")
            .map((c) => "%" + c.codePointAt(0).toString(16).padStart(2, "0"))
            .join("")
        );
        return JSON.parse(json);
      } catch (e) {
        console.warn("Token de materiais inválido:", e.message);
        return null;
      }
    },
    resolveEventosReturnUrl(ret) {
      const isAllowed = (url) =>
        /^https?:\/\/([^/]+\.)?ifoodeventos\.com([/:?#]|$)/.test(url) ||
        /^https?:\/\/localhost(:\d+)?([/:?#]|$)/.test(url);
      if (ret && isAllowed(ret)) {
        return ret;
      }
      const referrer = document.referrer || "";
      if (/(^|\.)ifoodeventos\.com/.test(referrer)) {
        return referrer;
      }
      return "";
    },
    async handleEncryptedToken(encryptedToken) {
      this.isLoadingToken = true;
      
      try {
        const userData = encryptionService.decryptUserData(encryptedToken);
        
        if (!userData) {
          console.error("Falha ao descriptografar token");
          this.showError("Token inválido. Faça login normalmente.");
          return;
        }

        if (!encryptionService.validateUserData(encryptedToken)) {
          console.warn("Token expirado ou inválido");
          this.showError("Token expirado. Faça login normalmente.");
          return;
        }

        const response = await userService.getDriverData(userData.uuid);
        
        if (response.status === 200 && response.data) {
          await this.autoLogin(response.data);
        } else {
          this.prefillRegistration(userData);
        }
        
      } catch (error) {
        console.error("Erro ao processar token:", error);
        
        if (error.response && error.response.status === 404) {
          try {
            const userData = encryptionService.decryptUserData(encryptedToken);
            this.prefillRegistration(userData);
          } catch (decryptError) {
            console.error("Erro ao descriptografar para registro:", decryptError);
            this.showError("Erro ao processar seus dados. Tente novamente.");
          }
        } else {
          this.showError("Erro ao verificar usuário. Tente novamente.");
        }
      } finally {
        this.isLoadingToken = false;
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    },
    async autoLogin(driverData) {
      const { uuid, name, cpf, region } = driverData;
      
      const driverPayload = {
        tk: uuid,
        doc: cpf,
        nam: name,
        region: region,
        uid: uuid
      };
      
      await this.driver(driverPayload);
    },
    prefillRegistration(userData) {
      this.show = false;
      this.prefilledFromToken = true;
      
      if (userData.name) this.sign.name = userData.name;
      if (userData.email) this.sign.email = userData.email;
      if (userData.cpf) this.sign.document = userData.cpf;
      
      this.message = "Complete seu cadastro com as informações adicionais";
      this.show_msg = true;
      setTimeout(() => {
        this.show_msg = false;
      }, 5000);
    },
    showError(errorMessage) {
      this.message = errorMessage;
      this.show_msg = true;
      setTimeout(() => {
        this.show_msg = false;
      }, 5000);
    },
    async onLogIn() {
      sessionStorage.clear();
      const data = {
        username: this.form.email,
        password: this.form.password,
      };
      this.checked = true;
      await this.login(data).then(() => {
        console.log("asd", this.isAuthenticated);
        if (this.isAuthenticated) {
          this.$router.push("/meus-materiais");
        } else {
          this.validateForm.errorM = true;
          this.validateForm.errorP = true;
          this.validateForm.errorPassword = "Usuário ou senha inválidos";
          setTimeout(() => {
            this.validateForm.errorPassword = "";
            this.validateForm.errorM = false;
            this.validateForm.errorP = false;
          }, 8000);
        }
      });
    },
    async onSignin() {
      
      if (!this.checkPassword()) {
        this.sign.errorPassword = true;
        this.sign.errorMsg =
          "Senha deve conter no mínimo 8 caracteres, letra maiúscula, letra minúscula, número e caractere especial";
        setTimeout(() => {
          this.sign.errorMsg = "";
          this.sign.errorPassword = false;
        }, 8000);
      } else if (this.sign.confirmPassword != this.sign.password) {
        this.sign.errorPassword = true;
        this.sign.errorMsg = "As senhas devem ser iguais";
        setTimeout(() => {
          this.sign.errorMsg = "";
          this.sign.errorPassword = false;
        }, 8000);
      } else {
        this.checked = true;
        await this.buscaCep()

        const data = {
        name: this.sign.name,
        corporate_name: this.sign.company,
        document: this.sign.document,
        email: this.sign.email,
        password: this.sign.password,
        city: this.sign.city,
        zipCode: this.sign.zipCode,
      };

        await this.signin(data).then((res) => {
          this.message = res + "!";
          this.show_msg = true;
          setTimeout(() => {
            this.show_msg = false;
            window.location.reload();
          }, 3000);
        });
      }
    },
    async buscaCep() {
      if (this.sign.zipCode.length == 9) {
        var response = await this.searchZip({
          zip: this.sign.zipCode.replace("-", ""),
        });
        console.log(response)
        if (response.erro) {
          console.log("erro");
        } else {
          this.address =
            response.logradouro +
            ", " +
            response.bairro +
            ", " +
            response.localidade +
            ", " +
            response.uf;
          this.sign.city = response.localidade;
          this.sign.neighborhood = response.bairro;
          this.sign.state = response.uf;
          this.sign.street = response.logradouro;
          console.log(this.sign.street)
        }
      }
    },
    signIn() {
      this.show = false;
    },
    checkPassword() {
      const regex =
        /^(?=.*\d)(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#!=+.-])[0-9a-zA-Z$*&@#!=+.-]{8,}$/;
      return regex.test(this.sign.password);
    },
  },

  components: { InputForm },
};
</script>

<style scoped>
.login_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 80%;
  height: 100vh;
  margin: 0 auto;
}
.login_wrapper .alert {
  position: fixed;
  top: 20px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.login_wrapper img {
  margin-top: 90px;
  height: clamp(70px, 7.16vw, 120px);
}
.login_wrapper > h1 {
  margin: 0;
  font-size: 17px;
  font-weight: lighter;
}
#submit-btn {
  padding: 7px 29px;
  font-size: 16px;
  letter-spacing: 0px;
  color: var(--light);
  background-color: var(--red);
  border: none;
  transition: all 0.3s ease-in-out;
  margin-bottom: 30px;
}
#submit-btn:hover {
  opacity: 0.8;
}
#sign_btn {
  color: var(--red);
  border: none;
  background: none;
  transition: all 0.3s ease-in-out;
}
#sign_btn:hover {
  opacity: 0.7;
}

@media screen and (max-width: 1100px) {
  .login_wrapper > h1 {
    width: clamp(250px, 25vw, 500px);
  }
}
</style>
